/* ---------------- FOOD DATABASE ---------------- */

export const FOOD_DB = [
  { name: "banana", tags: ["vegan", "soft", "fruit"] },
  { name: "yogurt", tags: ["vegetarian", "dairy", "soft", "probiotic"] },
  { name: "toast", tags: ["vegetarian", "gluten", "crispy"] },
  { name: "egg", tags: ["eggetarian", "soft", "protein"] },
  { name: "cheese", tags: ["dairy", "vegetarian", "soft"] },
  { name: "fruit bowl", tags: ["vegan", "fruit"] },
  { name: "oats", tags: ["vegan", "soft", "grain"] },
  { name: "idli", tags: ["vegan", "soft", "indian", "rice"] },
  { name: "dosa", tags: ["vegan", "indian", "crispy"] },
  { name: "paneer", tags: ["dairy", "vegetarian", "indian", "protein"] },
  { name: "pasta", tags: ["vegetarian", "gluten", "soft", "italian"] },
  { name: "breadsticks", tags: ["vegetarian", "gluten", "crispy", "italian"] },
  { name: "risotto", tags: ["vegetarian", "soft", "grain", "italian"] },
  { name: "polenta", tags: ["vegetarian", "soft", "grain", "italian"] },
  { name: "mozzarella", tags: ["dairy", "vegetarian", "soft", "italian"] },
  { name: "minestrone soup", tags: ["vegetarian", "soft", "vegetable", "italian"] },
  { name: "gnocchi", tags: ["vegetarian", "soft", "italian"] },
  { name: "focaccia", tags: ["vegetarian", "gluten", "chewy", "italian"] },
  { name: "apple", tags: ["vegan", "fruit", "crispy"] },
  { name: "carrot sticks", tags: ["vegan", "vegetable", "crispy"] },
  { name: "cucumber", tags: ["vegan", "vegetable", "crispy"] },
  { name: "rice", tags: ["vegan", "soft", "grain", "indian", "chinese", "japanese"] },
  { name: "potato", tags: ["vegan", "soft", "vegetable"] },
  { name: "chicken nuggets", tags: ["meat", "crispy", "protein"] },
  { name: "fish fingers", tags: ["seafood", "crispy", "protein"] },
  { name: "smoothie", tags: ["vegan", "soft", "fruit"] },
  { name: "soup", tags: ["vegan", "soft", "vegetable"] },
  { name: "sandwich", tags: ["vegetarian", "gluten", "soft"] },
  { name: "pizza", tags: ["vegetarian", "gluten", "chewy", "italian"] },
  { name: "noodles", tags: ["vegan", "soft", "chinese"] },
  { name: "tacos", tags: ["vegetarian", "mexican", "crispy"] }
];

/* ---------------- FILTER FUNCTIONS ---------------- */

export const CUISINE_TAGS = ["indian", "italian", "chinese", "mexican", "japanese"];

export const applyFilters = (foodList, preferences, allergies, cuisines = []) => {
  const selectedCuisineTags = cuisines
    .map((cuisine) => cuisine.toLowerCase())
    .filter((cuisine) => CUISINE_TAGS.includes(cuisine));

  return foodList.filter((item) => {
    const tags = item.tags;

    if (
      selectedCuisineTags.length > 0 &&
      !selectedCuisineTags.some((cuisine) => tags.includes(cuisine))
    ) {
      return false;
    }

    // Check allergies (exclude if any allergy matches)
    if (allergies && allergies.length > 0) {
      const hasAllergy = allergies.some(allergy =>
        tags.includes(allergy.toLowerCase())
      );
      if (hasAllergy) return false;
    }

    // Check preferences
    if (preferences) {
      const pref = preferences.toLowerCase();
      if (pref === "vegan" && !tags.includes("vegan")) return false;
      if (pref === "vegetarian" && tags.includes("meat")) return false;
      if (pref === "eggetarian" && !tags.includes("eggetarian") && !tags.includes("vegan")) return false;
    }

    return true;
  });
};

/* ---------------- SUGGESTION ENGINE ---------------- */

export const generateSuggestions = (cuisine, texture, location, concerns) => {
  let base = ["banana", "yogurt", "toast", "egg", "cheese", "fruit", "oats"];

  // Cuisine-based additions
  if (cuisine === "Indian") base.push("idli", "dosa", "paneer");
  if (cuisine === "Italian") base.push("pasta", "breadsticks");
  if (cuisine === "Chinese") base.push("noodles", "rice");
  if (cuisine === "Mexican") base.push("tacos");
  if (cuisine === "Japanese") base.push("rice", "seaweed");

  // Texture-based filtering
  if (texture === "Soft") {
    base = base.filter(item =>
      !["toast", "breadsticks", "carrot sticks", "cucumber"].includes(item)
    );
  }
  if (texture === "Crispy") {
    base = base.filter(item =>
      ["toast", "breadsticks", "carrot sticks", "cucumber", "dosa"].includes(item)
    );
  }

  // Location-based adjustments (could be expanded)
  if (location && location.toLowerCase().includes("india")) {
    base.push("idli", "dosa");
  }

  // Concerns-based adjustments (basic implementation)
  if (concerns && concerns.toLowerCase().includes("sick")) {
    base = base.filter(item => ["banana", "rice", "soup", "smoothie"].includes(item));
  }
  if (concerns && concerns.toLowerCase().includes("weight")) {
    base = base.filter(item => ["oats", "fruit", "yogurt"].includes(item));
  }

  return {
    next: base.slice(0, 3),
    upgrade: base.slice(3, 7)
  };
};

/* ---------------- UTILITY FUNCTIONS ---------------- */

export const getRandomReassurance = () => {
  const lines = [
    "You're doing great. Small steps matter.",
    "Every bite counts — this is progress.",
    "You're learning what works for your child.",
    "No pressure. Exposure is success too."
  ];
  return lines[Math.floor(Math.random() * lines.length)];
};
